'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment-timezone'));

var LiveClock = function (props) {
    var timezone = props.timezone, _a = props.interval, interval = _a === void 0 ? 5000 : _a, render = props.render, startTime = props.startTime;
    var difference = 0;
    if (startTime) {
        difference = new Date(startTime).getTime() - Date.now();
    }
    var _b = React.useState(Date.now() + difference), currentTime = _b[0], setCurrentTime = _b[1];
    React.useEffect(function () {
        var tick = setInterval(function () {
            setCurrentTime(Date.now() + difference);
        }, interval);
        return function () { return clearInterval(tick); };
    }, [interval]);
    var tzMoment = moment(currentTime).tz(timezone);
    return React__default.createElement(React__default.Fragment, null, render(tzMoment));
};

module.exports = LiveClock;
